import React from 'react';
import { responsiveFont, responsivePaddingVertical, responsivePaddingHorizontal, HorizontalPadding, responsiveImageSize } from '../../common/responsive.utils';
import useMediaQuery from '@mui/material/useMediaQuery';
import QuestionOnIcon from '../../../assets/icon/sitter/mobile/question_on.svg';
import QuestionOffIcon from '../../../assets/icon/sitter/mobile/question_off.svg';

const Content07BrowserComponent = ({...props}) : React.ReactElement => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles();

    const [visible01Web, setVisible01Web] = React.useState(false);
    const [visible02Web, setVisible02Web] = React.useState(false);
    const [visible03Web, setVisible03Web] = React.useState(false);
    const [visible04Web, setVisible04Web] = React.useState(false);
    const [visible05Web, setVisible05Web] = React.useState(false);

    const [visible01Mobile, setVisible01Mobile] = React.useState(false);
    const [visible02Mobile, setVisible02Mobile] = React.useState(false);
    const [visible03Mobile, setVisible03Mobile] = React.useState(false);
    const [visible04Mobile, setVisible04Mobile] = React.useState(false); 
    const [visible05Mobile, setVisible05Mobile] = React.useState(false); 

    return (
        <>
            {isWeb ? (
                <>
                    <div style={styles.com7ColorConn_Web}>
                        <span style={styles.title_Web}>
                            자주 묻는 질문
                        </span>

                        <div style={{ height: 30 }} />

                        <div style={visible01Web ? styles.selectedCon_Web : styles.unSelectedCon_Web} onClick={() => { setVisible01Web(!visible01Web) }}>
                            <div style={styles.rowCon_Web}>
                                {
                                    (visible01Web) ? <img src={QuestionOnIcon} style={styles.questionIcon_Web} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Web} alt="?" />
                                }
                                <div style={styles.colCon_Web}>
                                    <span style={(visible01Web) ? styles.titleTxt_Web : styles.unSelectInfoTxt_Web}>
                                        중개 비용 및 중개 수수료가 있나요?
                                    </span>
                                </div>
                            </div>
                        </div>

                        {
                            (visible01Web) ?
                                <span style={styles.contentTxt_Web}>
                                    없어요. 우주펫은 채팅 및 돌봄거래의 모든 과정에서 이용료 및 수수료를 받고 있지 않아요.
                                </span>
                            : null
                        }

                        <div style={visible02Web ? styles.selectedCon_Web : styles.unSelectedCon_Web} onClick={() => { setVisible02Web(!visible02Web) }}>
                            <div style={styles.rowCon_Web}>
                                {
                                    (visible02Web) ? <img src={QuestionOnIcon} style={styles.questionIcon_Web} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Web} alt="?" />
                                }
                                <div style={styles.colCon_Web}>
                                    <span style={(visible02Web) ? styles.titleTxt_Web : styles.unSelectInfoTxt_Web}>
                                        돌봄이 필요한 이웃은 어떻게 찾나요?
                                    </span>
                                </div>
                            </div>
                        </div>

                        {
                            (visible02Web) ?
                            <span style={styles.contentTxt_Web}>
                                1. &nbsp; 돌봄 요청글을 보고 이웃시터님이 이웃에게 연락할 수 있어요.
                                <br/>
                                2. &nbsp;돌봄이 필요한 이웃이 이웃시터님의 프로필을 보고 채팅을 통해 연락할 수 있어요.
                            </span>
                        : null
                        }


                        <div style={visible03Web ? styles.selectedCon_Web : styles.unSelectedCon_Web} onClick={() => { setVisible03Web(!visible03Web) }}>
                            <div style={styles.rowCon_Web}>
                                {
                                    (visible03Web) ? <img src={QuestionOnIcon} style={styles.questionIcon_Web} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Web} alt="?" />
                                }
                                <div style={styles.colCon_Web}>
                                    <span style={(visible03Web) ? styles.titleTxt_Web : styles.unSelectInfoTxt_Web}>
                                        이웃시터가 뭔가요?
                                    </span>
                                </div>
                            </div>
                        </div>

                        {
                            (visible03Web) ?
                                <span style={styles.contentTxt_Web}>
                                    이웃시터란 우주펫에서 활동하는 펫시터를 의미해요.
                                </span> 
                            : null
                        } 

                        <div style={visible04Web ? styles.selectedCon_Web : styles.unSelectedCon_Web} onClick={() => { setVisible04Web(!visible04Web) }}>
                            <div style={styles.rowCon_Web}>
                                {
                                    (visible04Web) ? <img src={QuestionOnIcon} style={styles.questionIcon_Web} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Web} alt="?" />
                                }
                                <div style={styles.colCon_Web}>
                                    <span style={(visible04Web) ? styles.titleTxt_Web : styles.unSelectInfoTxt_Web}>
                                        비용은 어떻게 받나요?
                                    </span>
                                </div>
                            </div>
                        </div>

                        {
                            (visible04Web) ?
                                <div style={styles.colCon_Web}>
                                    <span style={styles.contentTxt_Web}>
                                        채팅방 내에서 예약을 통해 사례비를 결제 받으면 일정이 생성돼요.
                                        <br/>
                                        돌봄이 완료되면 보호자님이 결제한 사례비를 지급받을 수 있어요.
                                    </span>
                                </div>
                            : null
                        }
                        <div style={visible05Web ? styles.selectedCon_Web : styles.unSelectedCon_Web} onClick={() => { setVisible05Web(!visible05Web) }}>
                            <div style={styles.rowCon_Web}>
                                {
                                    (visible05Web) ? <img src={QuestionOnIcon} style={styles.questionIcon_Web} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Web} alt="?" />
                                }
                                <div style={styles.colCon_Web}>
                                    <span style={(visible05Web) ? styles.titleTxt_Web : styles.unSelectInfoTxt_Web}>
                                        필수 교육은 무엇인가요?
                                    </span>
                                </div>
                            </div>
                        </div>

                        {
                            (visible05Web) ?
                                <div style={styles.colCon_Web}>
                                    <span style={styles.contentTxt_Web}>
                                        우주펫과 전문 교육 기관인 하울팟이 공동 제작한 우주펫 시터 대상 교육이에요.
                                    <br/>
                                        이웃시터 활동을 위해 교육을 필수로 수강해주셔야 하며,
                                        수강 후 테스트에 통과한 지원자분들만 이웃시터로 활동하실 수 있어요.
                                    </span>
                                </div>
                            : null
                        }

                    </div>
                </>
            ) : (
                <>
                    <div style={styles.screen_Mobile}>
                        <span style={styles.title_Mobile}>
                            자주 묻는 질문
                        </span>

                        <div style={{ height: "2vh" }} />

                        <div style={visible01Mobile ? styles.selectedCon_Mobile : styles.unSelectedCon_Mobile} onClick={() => { setVisible01Mobile(!visible01Mobile) }}>
                            <div style={styles.colCon_Mobile}>
                                <div style={styles.rowCon_Mobile}>
                                    {
                                        (visible01Mobile) ? <img src={QuestionOnIcon} style={styles.questionIcon_Mobile} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Mobile} alt="?" />
                                    }
                                    <span style={(visible01Mobile) ? styles.titleTxt_Mobile : styles.unSelectInfoTxt_Mobile}>
                                        중개 비용 및 중개 수수료가 있나요?
                                    </span>
                                </div>
                                <div style={styles.colCon_Mobile}>
                                    {
                                        (visible01Mobile) ?
                                            <span style={styles.contentTxt_Mobile}>
                                                없어요. 우주펫은 채팅 및 돌봄거래의 모든 과정에서 이용료 및 수수료를 받고 있지 않아요.
                                            </span>
                                        : null
                                    }
                                </div>
                            </div>
                        </div>

                        <div style={visible02Mobile ? styles.selectedCon_Mobile : styles.unSelectedCon_Mobile} onClick={() => { setVisible02Mobile(!visible02Mobile) }}>
                            <div style={styles.colCon_Mobile}>
                                <div style={styles.rowCon_Mobile}>
                                    {
                                        (visible02Mobile) ? <img src={QuestionOnIcon} style={styles.questionIcon_Mobile} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Mobile} alt="?" />
                                    }
                                    <span style={(visible02Mobile) ? styles.titleTxt_Mobile : styles.unSelectInfoTxt_Mobile}>
                                        돌봄이 필요한 이웃은 어떻게 찾나요?
                                    </span>
                                </div>
                                <div style={styles.colCon_Mobile}>
                                    {
                                        (visible02Mobile) ?
                                            <span style={styles.contentTxt_Mobile}>
                                                1. &nbsp; 돌봄 요청글을 보고 이웃시터님이 이웃에게 연락할 수 있어요.
                                                <br />
                                                2. &nbsp;돌봄이 필요한 이웃이 이웃시터님의 프로필을 보고 채팅을 통해 연락할 수 있어요.
                                            </span>
                                        : null
                                    }
                                </div>
                            </div>
                        </div>

                        <div style={visible03Mobile ? styles.selectedCon_Mobile : styles.unSelectedCon_Mobile} onClick={() => { setVisible03Mobile(!visible03Mobile) }}>
                            <div style={styles.colCon_Mobile}>
                                <div style={styles.rowCon_Mobile}>
                                    {
                                        (visible03Mobile) ? <img src={QuestionOnIcon} style={styles.questionIcon_Mobile} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Mobile} alt="?" />
                                    }
                                    <span style={(visible03Mobile) ? styles.titleTxt_Mobile : styles.unSelectInfoTxt_Mobile}>
                                        이웃시터가 뭔가요?
                                    </span>
                                </div>
                                <div style={styles.colCon_Mobile}>
                                    {
                                        (visible03Mobile) ?
                                            <span style={styles.contentTxt_Mobile3}>
                                                이웃시터란 우주펫에서 활동하는 펫시터를 의미해요.
                                            </span>
                                        : null
                                    }
                                </div>
                            </div>
                        </div>

                        <div style={visible04Mobile ? styles.selectedCon_Mobile : styles.unSelectedCon_Mobile} onClick={() => { setVisible04Mobile(!visible04Mobile) }}>
                            <div style={styles.colCon_Mobile}>
                                <div style={styles.rowCon_Mobile}>
                                    {
                                        (visible04Mobile) ? <img src={QuestionOnIcon} style={styles.questionIcon_Mobile} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Mobile} alt="?" />
                                    }
                                    <span style={(visible04Mobile) ? styles.titleTxt_Mobile : styles.unSelectInfoTxt_Mobile}>
                                            비용은 어떻게 받나요?
                                    </span>
                                </div>
                                <div style={styles.colCon_Mobile}>
                                    {
                                        (visible04Mobile) ?
                                            <span style={styles.contentTxt_Mobile}>
                                                채팅방 내에서 예약을 통해 사례비를 결제 받으면 일정이 생성돼요.
                                                돌봄이 완료되면 보호자님이 결제한 사례비를 지급받을 수 있어요.
                                            </span>
                                        : null
                                    }
                                </div>
                            </div>
                        </div>
                            <div style={visible05Mobile ? styles.selectedCon_Mobile : styles.unSelectedCon_Mobile} onClick={() => { setVisible05Mobile(!visible05Mobile) }}>
                            <div style={styles.colCon_Mobile}>
                                <div style={styles.rowCon_Mobile}>
                                    {
                                            (visible05Mobile) ? <img src={QuestionOnIcon} style={styles.questionIcon_Mobile} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Mobile} alt="?" />
                                    }
                                        <span style={(visible05Mobile) ? styles.titleTxt_Mobile : styles.unSelectInfoTxt_Mobile}>
                                            필수 교육은 무엇인가요?
                                    </span>
                                </div>
                                <div style={styles.colCon_Mobile}>
                                    {
                                        (visible05Mobile) ?
                                        <span style={styles.contentTxt_Mobile}>
                                            우주펫과 전문 교육 기관인 하울팟이 공동 제작한 우주펫 시터 대상 교육이에요. 이웃시터 활동을 위해 교육을 필수로 수강해주셔야 하며, 수강 후 테스트에 통과한 지원자분들만 이웃시터로 활동하실 수 있어요.
                                        </span>
                                        : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    title_Web: { fontSize: responsiveFont(20, 40), fontWeight: 700, letterSpacing: -0.3, alignSelf: "flex-start", lineHeight: "120%",  paddingLeft: HorizontalPadding(24, 88) },
    titleTxt_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(16, 28), fontWeight: 600, letterSpacing: "-1%", color: "black", lineHeight: "140%" },
    unSelectInfoTxt_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(16, 28), fontWeight: 400, letterSpacing: "-1%", color: "#454A50", lineHeight: "140%" },
    contentTxt_Web: { marginLeft: HorizontalPadding(24, 88), fontFamily: "Pretendard", fontSize: responsiveFont(14, 24), fontWeight: 400, letterSpacing: "-2%", color: "#62686D", lineHeight: "150%", paddingLeft: "18px", paddingRight: "18px", paddingTop: "22px", paddingBottom: "22px", marginBottom: "26px", borderRadius: "16px", backgroundColor: "#FAFAFB", width: "90%" },
    unSelectedCon_Web: { marginLeft: HorizontalPadding(24, 88), width: "90%",    paddingRight: "18px", paddingTop: HorizontalPadding(14, 26), paddingBottom: HorizontalPadding(14, 26), display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", boxSizing: "border-box", borderBottom: "0.1px solid rgb(232, 232, 233)" },
    selectedCon_Web: { width: "90%", backgroundColor: "#FFFFFF", paddingLeft: HorizontalPadding(24, 88), paddingRight: "22px", paddingTop: "18px", paddingBottom: "18px", display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", boxSizing: "border-box" },
    rowCon_Web: { display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start" },
    colCon_Web: { display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", marginLeft: 6 ,},
    questionIcon_Web: { width: responsiveImageSize(22, 39), height: responsiveImageSize(22, 39) },
    com7ColorConn_Web: { backgroundColor: "#fff", boxSizing: "border-box", display: "flex", flexDirection: "column", paddingBottom: responsivePaddingVertical(50, 90), paddingTop: responsivePaddingVertical(50, 90), paddingLeft: responsivePaddingHorizontal(24, 88), paddingRight: responsivePaddingHorizontal(24, 88) },

    screen_Mobile: { width: "100%", minWidth: "320px", backgroundColor: "white", display: "flex", flexDirection: "column", boxSizing: "border-box", paddingBottom: "7.8125vh", paddingTop: "4.6875vh"},
    title_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(20, 40), fontWeight: 700, letterSpacing: "-1%", alignSelf: "flex-start", paddingLeft: "7.5vw", lineHeight: "120%" },
    titleTxt_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(16, 28), fontWeight: 600, letterSpacing: "-1%", color: "black", lineHeight: "140%" },
    unSelectInfoTxt_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(16, 28), fontWeight: 400, letterSpacing: "-1%", color: "#454A50", lineHeight: "140%" },
    contentTxt_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(14, 24), fontWeight: 400, letterSpacing: "-2%", color: "#62686D", marginTop: "2.5vw", lineHeight: "150%", paddingLeft: "18px", paddingRight: "18px", paddingTop: "22px", paddingBottom: "22px", borderRadius: "16px", backgroundColor: "#FAFAFB", width: "90%" },
    contentTxt_Mobile3: { fontFamily: "'Pretendard'", fontSize: responsiveFont(14, 24), fontWeight: 400, letterSpacing: "-2%", color: "#62686D", marginTop: "2.5vw", lineHeight: "150%", paddingLeft: "18px", paddingRight: "18px", paddingTop: "22px", paddingBottom: "22px", borderRadius: "16px", backgroundColor: "#FAFAFB", width: "77.5vw" },
    unSelectedCon_Mobile: { width: "100%", paddingTop: HorizontalPadding(14, 26), paddingBottom: HorizontalPadding(14, 26), paddingLeft: HorizontalPadding(24, 88), paddingRight: "6.5vw", display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", boxSizing: "border-box" },
    selectedCon_Mobile: { width: "100%", display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", boxSizing: "border-box", paddingTop: HorizontalPadding(14, 26), paddingBottom: HorizontalPadding(14, 26), paddingLeft: HorizontalPadding(24, 88), paddingRight: "6.5vw", },
    rowCon_Mobile: { display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start" },
    colCon_Mobile: { display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" },
    questionIcon_Mobile: { width: responsiveImageSize(22, 39), height: responsiveImageSize(22, 39), boxSizing: "border-box", marginRight: "1.8750vw" },
});

export default Content07BrowserComponent;